import { RESTError } from "../core/RESTError";

/**
 * An error that occurs when no link was provided to a docu of a product, neither a release specific link nor a default product one.
 */
export class MissingDocuLinkError extends RESTError {}
